/* =====================================================================
   Bunch — BUY 2 GET 2 FREE: page controller            (added 2026-07-30)
   =====================================================================
   RESPONSIBILITIES
     1. Keep an accurate, cart-derived count of QUALIFYING PAID items.
     2. Fire the free-pick sheet the moment that count hits 2.
     3. Put the chosen free variants in the cart tagged _b2g2_free.
     4. Keep the sticky rail honest about what is in the cart.

   WHAT IT DOES NOT DO
     It never sets, implies or calculates a discount. The Rs.0 comes from a
     native Shopify automatic Buy-X-Get-Y discount. If this file 404s, the
     shopper can still buy normally and any free lines already in the cart
     are still discounted by Shopify. Fail-safe by design.

   THREE DECISIONS WORTH KNOWING BEFORE YOU EDIT

   1. THE COUNT IS VARIANT-ID BASED, NOT cart.item_count.
      cart.item_count includes the surprise Free Gift line, the free picks
      themselves, and anything bought outside the campaign. Counting the
      eligible variant allow-list from snippets/bunch-b2g2-config is the only
      way the on-page counter is guaranteed to agree with what Shopify's
      discount engine will actually do. A counter that promises a reward the
      checkout then refuses is the most expensive bug this page could ship.

   2. QUANTITY WRITES GO BY LINE KEY, NEVER BY VARIANT ID.
      A shopper can hold the same jar on two lines — one added here (tagged
      _b2g2) and one added earlier from the PDP (untagged). /cart/change.js
      given a variant id hits whichever line it finds first, so the card's
      minus button could silently decrement the shopper's OTHER line. So
      state.lines stores the line key of the campaign-tagged line and every
      write uses it.
      Note the asymmetry, it is deliberate: state.paid counts EVERY eligible
      unit in the cart (tagged or not, because Shopify's discount counts them
      all), while state.lines only tracks lines this page created (because
      those are the only ones its steppers may touch).

   3. TAB FILTERING USES style.display, NOT THE hidden ATTRIBUTE.
      .b2g2-card sets display:flex, which beats [hidden]'s display:none in
      the cascade — hidden cards would stay visible. Setting display inline
      sidesteps the whole specificity question.
   ===================================================================== */
(function () {
  'use strict';

  var CFG = window.BUNCH_B2G2;
  if (!CFG) return;

  var root = document.querySelector('[data-b2g2-root]');
  if (!root) return;

  var REQUIRED = CFG.requiredPaid || 2;
  var FREE_N = CFG.freeCount || 2;
  var BONUS_MIN = CFG.bonusMinItems || 5;
  var eligibleSet = {};
  (CFG.eligibleVariantIds || []).forEach(function (id) { eligibleSet[String(id)] = true; });

  var state = {
    paid: 0,           // every qualifying paid unit in the cart
    free: 0,           // free-pick units in the cart
    total: 0,          // cart total in paise, AFTER discounts
    lines: {},         // variantId -> { qty, key } for campaign-tagged lines only
    sheetSeen: false,
    busy: false
  };

  try {
    state.sheetSeen = sessionStorage.getItem('b2g2_sheet_seen') === '1';
  } catch (e) { /* private mode */ }

  /* ------------------------------------------------------------- helpers */
  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }

  /* Uses the shop's own money_format so the rail never disagrees with the
     Liquid-rendered prices on the cards. Trailing zeros dropped to match
     money_without_trailing_zeros, which is what the cards use. */
  function money(paise) {
    var amount = ((paise || 0) / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    var fmt = (CFG.money && CFG.money.format) || '₹{{amount}}';
    return fmt.replace(/\{\{\s*amount[_a-z]*\s*\}\}/, amount);
  }

  function track(name, payload) {
    document.dispatchEvent(new CustomEvent('bunch:b2g2:' + name, { detail: payload || {} }));
    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push(Object.assign({ event: 'b2g2_' + name }, payload || {}));
    }
  }

  var toastEl = $('[data-b2g2-toast]');
  var toastTimer = null;
  function toast(msg, warn) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.toggle('b2g2-toast--warn', !!warn);
    toastEl.classList.add('b2g2-toast--on');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('b2g2-toast--on');
    }, 3200);
  }

  /* --------------------------------------------------------- cart reading */
  function readCart() {
    return fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var paid = 0, free = 0, lines = {};
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          if (props._b2g2_free === 'true') { free += item.quantity; return; }
          if (props._free_gift === 'true') return;             // surprise gift, not ours
          if (!eligibleSet[String(item.variant_id)]) return;   // outside the campaign

          paid += item.quantity;                               // counts like Shopify counts

          if (props._b2g2 === 'true') {                        // ours to control
            var k = String(item.variant_id);
            lines[k] = { qty: (lines[k] ? lines[k].qty : 0) + item.quantity, key: item.key };
          }
        });
        state.paid = paid;
        state.free = free;
        state.total = cart.total_price;
        state.lines = lines;
        return cart;
      })
      .catch(function () { return null; });
  }

  function unitsOf(variantId) {
    var l = state.lines[String(variantId)];
    return l ? l.qty : 0;
  }

  /* --------------------------------------------------------- cart writing */
  function repaintTheme() {
    // constants.js owns drawer repainting; reuse it rather than duplicating.
    if (window.BunchCartUI && window.BunchCartUI.refreshFromServer) {
      window.BunchCartUI.refreshFromServer();
    }
  }

  function addItems(items) {
    state.busy = true;
    return fetch(CFG.routes.add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        state.busy = false;
        if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add that');
        return res.data;
      })
      .catch(function (err) {
        state.busy = false;
        throw err;
      });
  }

  /* key, not variant id — see decision 2 in the header */
  function setLineByKey(key, quantity) {
    return fetch(CFG.routes.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* -------------------------------------------------------------- the band */
  var band = {
    msg: $('[data-b2g2-band-msg]'),
    count: $('[data-b2g2-band-count]'),
    fill: $('[data-b2g2-band-fill]')
  };

  function bandCopy() {
    var left = REQUIRED - state.paid;
    if (state.paid === 0) return { t: 'Add any 2 jars — your 2 free picks unlock instantly', won: false };
    if (left > 0) return { t: '🔥 ' + left + ' more item' + (left === 1 ? '' : 's') + ' and you pick 2 FREE', won: false };
    if (state.free < FREE_N) return { t: '🎁 Unlocked — choose your ' + FREE_N + ' free picks', won: true };
    var toBonus = BONUS_MIN - state.paid;
    if (toBonus > 0) {
      return { t: '✅ ' + FREE_N + ' free picks locked in · ' + toBonus + ' more for 10% off', won: true };
    }
    return { t: '🎉 ' + FREE_N + ' free picks + 10% off — you are maxed out', won: true };
  }

  function renderBand() {
    var c = bandCopy();
    if (band.msg) {
      band.msg.textContent = c.t;
      band.msg.classList.toggle('b2g2-band__msg--won', c.won);
    }
    if (band.count) {
      band.count.textContent = Math.min(state.paid, REQUIRED) + '/' + REQUIRED + ' added';
    }
    if (band.fill) {
      var pct = state.paid >= REQUIRED
        ? (state.paid >= BONUS_MIN ? 100 : 60 + ((state.paid - REQUIRED) / (BONUS_MIN - REQUIRED)) * 40)
        : (state.paid / REQUIRED) * 60;
      band.fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    }
  }

  /* --------------------------------------------------------------- the rail */
  var rail = {
    el: $('[data-b2g2-rail]'),
    l1: $('[data-b2g2-rail-line1]'),
    l2: $('[data-b2g2-rail-line2]'),
    cta: $('[data-b2g2-rail-cta]')
  };

  function renderRail() {
    if (!rail.el) return;
    var show = state.paid > 0 || state.free > 0;
    rail.el.classList.toggle('b2g2-rail--on', show);
    if (!show) return;

    var needsPicks = state.paid >= REQUIRED && state.free < FREE_N;

    if (rail.l1) {
      rail.l1.textContent = needsPicks
        ? FREE_N + ' free picks waiting for you'
        : state.paid + ' item' + (state.paid === 1 ? '' : 's') +
          (state.free ? ' + ' + state.free + ' FREE' : '') +
          (state.paid < REQUIRED ? ' · ' + (REQUIRED - state.paid) + ' to unlock' : '');
    }
    if (rail.l2) rail.l2.textContent = money(state.total);

    if (rail.cta) {
      rail.cta.textContent = needsPicks ? 'Claim 2 free →' : (state.paid < REQUIRED ? 'View cart' : 'Checkout →');
      rail.cta.classList.toggle('b2g2-rail__cta--claim', needsPicks);
      rail.cta.dataset.action = needsPicks ? 'open-sheet' : (state.paid < REQUIRED ? 'cart' : 'checkout');
    }
  }

  /* --------------------------------------------------------------- the grid */
  function renderCards() {
    $$('[data-b2g2-card]').forEach(function (card) {
      var qty = unitsOf(card.dataset.b2g2Variant);
      card.classList.toggle('b2g2-card--picked', qty > 0);
      var badge = $('[data-b2g2-card-qty]', card);
      if (badge) badge.textContent = qty;
      var stepQty = $('[data-b2g2-step-qty]', card);
      if (stepQty) stepQty.textContent = qty;
    });
  }

  function render() {
    renderBand();
    renderRail();
    renderCards();
  }

  /* ------------------------------------------------- variant size switching */
  root.addEventListener('click', function (event) {
    var size = event.target.closest('[data-b2g2-size]');
    if (!size) return;
    var card = size.closest('[data-b2g2-card]');
    if (!card || size.disabled) return;

    $$('[data-b2g2-size]', card).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    size.setAttribute('aria-checked', 'true');

    card.dataset.b2g2Variant = size.dataset.b2g2Size;
    var priceEl = $('[data-b2g2-card-price]', card);
    if (priceEl) priceEl.textContent = size.dataset.b2g2Price;
    var addBtn = $('[data-b2g2-add]', card);
    if (addBtn) addBtn.disabled = size.dataset.b2g2Available !== 'true';
    renderCards();
  });

  /* -------------------------------------------------------------- adding */
  function addPaid(variantId, card) {
    var btn = card ? $('[data-b2g2-add]', card) : null;
    if (btn) btn.classList.add('b2g2-add--busy');

    return addItems([{ id: Number(variantId), quantity: 1, properties: { _b2g2: 'true' } }])
      .then(function () { return readCart(); })
      .then(function () {
        if (btn) btn.classList.remove('b2g2-add--busy');
        render();
        repaintTheme();
        track('add_paid', { variantId: variantId, paid: state.paid });
        maybeOpenSheet();
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('b2g2-add--busy');
        toast(String(err.message || 'Could not add that — please try again'), true);
      });
  }

  root.addEventListener('click', function (event) {
    var add = event.target.closest('[data-b2g2-add]');
    if (add) {
      var card = add.closest('[data-b2g2-card]');
      if (!card || state.busy) return;
      addPaid(card.dataset.b2g2Variant, card);
      return;
    }

    var step = event.target.closest('[data-b2g2-step]');
    if (step) {
      var c = step.closest('[data-b2g2-card]');
      if (!c) return;
      var vid = c.dataset.b2g2Variant;
      var line = state.lines[String(vid)];
      var up = step.dataset.b2g2Step === 'up';

      // No campaign line yet (shopper switched size, or their units came from
      // a PDP add): treat + as a fresh add and ignore -.
      if (!line) {
        if (up) addPaid(vid, c);
        return;
      }

      var next = up ? line.qty + 1 : line.qty - 1;
      if (next < 0) next = 0;
      setLineByKey(line.key, next)
        .then(readCart)
        .then(function () {
          render();
          repaintTheme();
          maybeOpenSheet();
        });
    }
  });

  /* ---------------------------------------------------------------- tabs */
  root.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-b2g2-tab]');
    if (!tab) return;
    var key = tab.dataset.b2g2Tab;
    $$('[data-b2g2-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', String(t === tab));
    });
    var shown = 0;
    $$('[data-b2g2-card]').forEach(function (card) {
      var match = key === 'all' || (card.dataset.b2g2Tags || '').indexOf('|' + key + '|') > -1;
      card.style.display = match ? '' : 'none';   // see decision 3 in the header
      if (match) shown++;
    });
    var empty = $('[data-b2g2-empty]');
    if (empty) empty.hidden = shown > 0;
    track('tab', { tab: key, results: shown });
  });

  /* ---------------------------------------------------------- free sheet */
  var sheet = $('[data-b2g2-sheet]');
  var picked = {};   // variantId -> units

  function pickedTotal() {
    return Object.keys(picked).reduce(function (s, k) { return s + picked[k]; }, 0);
  }

  function renderSheet() {
    var n = pickedTotal();
    $$('[data-b2g2-pick]', sheet).forEach(function (el) {
      var q = picked[el.dataset.b2g2Pick] || 0;
      el.setAttribute('aria-pressed', String(q > 0));
      var badge = $('[data-b2g2-pick-badge]', el);
      if (badge) badge.textContent = q > 1 ? '×' + q : '✓';
    });
    var cta = $('[data-b2g2-sheet-cta]', sheet);
    if (cta) {
      cta.disabled = n !== FREE_N;
      cta.textContent = n === FREE_N
        ? 'Add my ' + FREE_N + ' free picks →'
        : 'Pick ' + (FREE_N - n) + ' more';
    }
    var hint = $('[data-b2g2-sheet-hint]', sheet);
    if (hint) {
      hint.textContent = n === FREE_N
        ? 'Nice choice. Nothing to pay for these.'
        : 'Tap ' + FREE_N + ' — the same one twice is allowed.';
    }
  }

  function openSheet(source) {
    if (!sheet) return;
    sheet.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    state.sheetSeen = true;
    try { sessionStorage.setItem('b2g2_sheet_seen', '1'); } catch (e) {}
    renderSheet();
    var first = $('[data-b2g2-pick]:not([disabled])', sheet);
    if (first) first.focus();
    track('sheet_open', { source: source || 'auto', paid: state.paid });
  }

  function closeSheet(reason) {
    if (!sheet) return;
    sheet.removeAttribute('open');
    document.body.style.overflow = '';
    track('sheet_close', { reason: reason || 'dismiss' });
  }

  /* The sheet opens ONCE automatically, the instant the 2nd qualifying item
     lands. After that the gold rail button is the way back in — re-firing a
     modal on every subsequent add would be hostile and costs adds. */
  function maybeOpenSheet() {
    if (state.paid >= REQUIRED && state.free < FREE_N && !state.sheetSeen) {
      setTimeout(function () { openSheet('auto'); }, 260);
    }
  }

  if (sheet) {
    sheet.addEventListener('click', function (event) {
      if (event.target.closest('[data-b2g2-sheet-close]') || event.target.closest('[data-b2g2-scrim]')) {
        closeSheet('dismiss');
        toast('Your ' + FREE_N + ' free picks are still waiting — tap the gold button.');
        return;
      }

      var pick = event.target.closest('[data-b2g2-pick]');
      if (pick && !pick.disabled) {
        var vid = pick.dataset.b2g2Pick;
        var cur = picked[vid] || 0;
        if (pickedTotal() < FREE_N) {
          picked[vid] = cur + 1;
        } else if (cur > 0) {
          delete picked[vid];
        } else {
          toast('You can pick ' + FREE_N + '. Tap a selected one to undo.');
        }
        renderSheet();
        return;
      }

      var cta = event.target.closest('[data-b2g2-sheet-cta]');
      if (cta && !cta.disabled) {
        var items = Object.keys(picked).map(function (vid) {
          return { id: Number(vid), quantity: picked[vid], properties: { _b2g2_free: 'true' } };
        });
        cta.disabled = true;
        cta.textContent = 'Adding…';
        addItems(items)
          .then(readCart)
          .then(function () {
            picked = {};
            closeSheet('claimed');
            render();
            repaintTheme();
            toast('🎉 ' + FREE_N + ' free picks added — both at zero.');
            track('claim', { paid: state.paid, free: state.free });
          })
          .catch(function (err) {
            cta.disabled = false;
            renderSheet();
            toast(String(err.message || 'Could not add your free picks — try again'), true);
          });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && sheet.hasAttribute('open')) closeSheet('escape');
    });
  }

  /* ---------------------------------------------------------- rail actions */
  if (rail.cta) {
    rail.cta.addEventListener('click', function () {
      var action = rail.cta.dataset.action;
      if (action === 'open-sheet') { openSheet('rail'); return; }
      if (action === 'cart') { window.location.href = CFG.routes.cart; return; }
      track('checkout', { paid: state.paid, free: state.free, total: state.total });
      window.location.href = '/checkout';
    });
  }

  $$('[data-b2g2-scroll]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      var target = document.querySelector(el.dataset.b2g2Scroll);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ------------------------------------------------------- outside changes
     The cart can change from the drawer or another tab while this page is
     open. Re-read rather than trusting our own last known state. */
  document.addEventListener('bunch:gift-synced', function () { readCart().then(render); });
  document.addEventListener('bunch:b2g2:guard-removed', function () {
    readCart().then(function () {
      render();
      toast('Your free picks were removed — the offer needs ' + REQUIRED + ' paid items.', true);
    });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) readCart().then(render); });

  /* ------------------------------------------------------------------ boot */
  readCart().then(function () {
    render();
    // Someone who already had 2 qualifying items in the cart before landing
    // here should be shown the reward immediately — that is the whole point.
    maybeOpenSheet();
  });

  window.BunchB2G2 = {
    state: state,
    openSheet: openSheet,
    refresh: function () { return readCart().then(render); }
  };
})();
